import { ButtonPresentationProps } from "@insite/mobius/Button";
import { colors } from "@thkStore/theme/post/colors";
import { css } from "styled-components";

const primaryButton : ButtonPresentationProps = {
    buttonType: "outline",
    sizeVariant: "medium",
    shape: "pill",
    hoverMode: "none",
    hoverStyle: {
        backgroundColor: colors.primary.main,
    },
    typographyProps: {
        weight: "normal",
        lineHeight: "normal",
    },
    css: css`
        background-color:${colors.primary.contrast};
        border-width: 1px;

        &:hover {
            color: ${colors.primary.contrast};

            svg {
                stroke: ${colors.primary.contrast};
            }
        }

        &:disabled {

            &:hover {
                color: ${colors.common.disabled};
            }        
        }

        &:focus {
            outline: 0;
        }
    `,

}

const secondaryButton : ButtonPresentationProps = {
    color: "text.main",
    shape: "pill",
    typographyProps: {
        weight: "normal",
        lineHeight: "normal",
    },
    hoverStyle: {
        color: colors.primary.main,
        borderColor: colors.text.main,
    },
    css: css`
        &:disabled {

            &:hover {
                color: ${colors.common.disabled};
            }        
        }
    `,
}

const tertiaryButton : ButtonPresentationProps = {
    shape: "rounded",
    typographyProps: {
        weight: "normal",
        lineHeight: "normal",
    },
    css: css`
        color: ${colors.text.main};

        &:hover{
            color: ${colors.primary.main};
            background-color: ${colors.secondary.main};
            border-color: ${colors.secondary.main};
        }

        &:disabled {

            &:hover {
                color: ${colors.common.disabled};
            }        
        }

        [class^="IconWrapper-sc-"]{
            color: ${colors.primary.contrast};
            background-color: ${colors.primary.main};
            border-radius: 100%;
        }            
    `,
}

export const button = {
    primary: primaryButton,
    secondary: secondaryButton,
    tertiary: tertiaryButton,
};